// extracted by mini-css-extract-plugin
module.exports = {"root":"PageTracker_root__3N7iY"};